<template>
  <div ref="barChart" class="chart"></div>
</template>

<script>
import echarts from 'echarts';
import ChartStyleHelper from '@/helpers/chartStyleHelper';
import ChartFunctionHelper from '@/helpers/chartFunctionHelper';
import FuncHelper from '@/helpers/funcHelper';

const barChartColor = [
  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 1, color: '#0055ff' },
    { offset: 0, color: '#0055ff' }
  ])
];

export default {
  name: 'barChart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  methods: {
    preventLastSeriesUnseleted(chart) {
      chart.on('legendselectchanged', params => {
        const seletedCount = Object.keys(params.selected).map(key => {
          return {
            legend: key,
            selected: params.selected[key]
          };
        }).filter(item => item.selected).length;

        if (!seletedCount) {
          chart.dispatchAction({
            type: 'legendSelect',
            name: params.name
          });
        }
      });
    },
    resize() {
      if (this.chart) {
        FuncHelper.debounce(this.chart.resize, 300)();
      }
    },
    chartOption() {
      const displayOptions = this.data.displayOptions;
      const tooltip = Object.assign({}, ChartStyleHelper.tooltip, {
        backgroundColor: '#ffffff',
        borderRadius: 2,
        fontWeight: 500,
        boxShadow: '0px 6px 10px 0px rgba(10, 31, 68, 0.1)',
        border: '1px solid #f7f7fa',
        axisPointer: {
          type: 'shadow'
        },
        formatter(params) {
          return `<div style="padding: 10;"><div style="font-size: 12px; color: #171f46;">${
            params[0].name
          }</div>${params
            .map(v => `<div style="font-size: 14px; color: #171f46;">
            ${ChartStyleHelper.processDisplayOptions(
    v.data,
    displayOptions
  )}</div></div>`)
            .join('')
          }`;
        }
      });
      // const legend = Object.assign({}, ChartStyleHelper.legend, {
      //   textStyle: {
      //     fontSize: 14,
      //     color: '#3f4647'
      //   },
        // data: this.data.series.map(v => v.name)
      // });
      const grid = Object.assign({}, ChartStyleHelper.grid, {
        top: 10,
        left: 0,
        bottom: 0,
        right: 16
      });
      const dataPointCount = this.data.fields.length;
      const maxxAxisLabelCount = 5;
      const calcxAxisLabelCountIntervalThreshold = 20;
      const xAxisConfig = Object.assign({}, ChartStyleHelper.xAxisStyle, {
        type: 'category',
        axisLine: {
          lineStyle: {
            color: '#f2f3f7',
            width: 1
          }
        },
        axisLabel: {
          textStyle: {
            color: '#747990',
            fontSize: 12,
            fontFamily: 'Tahoma'
          },
          showMinLabel: true,
          showMaxLabel: true,
          interval:
            dataPointCount > calcxAxisLabelCountIntervalThreshold
              ? Math.floor(dataPointCount / (maxxAxisLabelCount + 1))
              : 'auto'
        },
        axisTick: {
          show: false
        },
        data: this.data.fields.map(v => {
          return {
            value: v,
            textStyle: {
              fontSize: 14
            }
          };
        })
      });
      const yAxisConfig = Object.assign({}, ChartStyleHelper.yAxisStyle, {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#f2f3f7',
            width: 1
          }
        },
        axisLabel: {
          padding: [0, 0, 0, 0],
          textStyle: {
            fontSize: 12,
            color: '#747990',
            fontFamily: 'Tahoma'
          },
          formatter: val => {
            return ChartStyleHelper.processDisplayOptions(val, displayOptions);
          }
        },
        // axisLine: {
        //   show: false
        // },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
          // lineStyle: {
          //   color: '#e6eff3',
          //   width: 1
          // }
        }
      });

      const option = {
        tooltip,
        // legend,
        grid,
        xAxis: [xAxisConfig],
        yAxis: [yAxisConfig],
        color: barChartColor,
        series: this.data.series.map(v => {
          return {
            name: v.name,
            type: 'bar',
            barMaxWidth: 40,
            data: this.data.fields.map(field => v[field])
          };
        })
      };
      return option;
    },
    generateChart() {
      const barChart = echarts.init(this.$refs.barChart);
      const option = this.chartOption();
      barChart.setOption(option);
      barChart.on('finished', () => {
        const imgUrl = barChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: '#fff'
        });
        this.$emit('done', imgUrl);
      });
      ChartFunctionHelper.preventLastSeriesUnseleted(barChart);
      return barChart;
    }
  },
  mounted() {
    this.chart = this.generateChart();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.chart) {
      this.chart.dispose();
      this.chart.off('finished');
    }
  }
};
</script>
<style lang="scss" scoped>
.chart{
  width: 100%;
  height: 166px;
}
</style>
